<div class="category-header d-flex px-3 py-3">
    <span nzType="arrow-left" nz-icon [routerLink]="['/dashboard']"> </span>
    <h5 class="mb-0 px-4">{{apiService.selectedCatalog}}</h5>
</div>

<div class="catalog-options-wrapper px-2">
    <ul class="nav">
        @for(item of catalogOptions;track item.id) {
        <li class="nav-item">
            <a (click)="handleTab(item)" [ngClass]="item.clicked ? 'active-tab' : ''"
                class="nav-link active">{{item.name}}</a>
        </li>
        }
    </ul>
</div>

<ng-container>
    <div class="p-3">
        @switch (activeTab) {
        @case ('Add/Edit Catalog') {
        <ng-container>
            <div class="p-1">
                <app-category-accordion *ngIf="catalogId != ''" class="col-md-5"
                    [catalogId]="catalogId"></app-category-accordion>
            </div>
        </ng-container>
        }
        @case ('Attributes') {
        <div class="p-1">
            <app-update-attributes [catalogId]="catalogId"></app-update-attributes>
        </div>
        }
        @case ('EDP/AR Mapping') {
        <div class="p-1">
            <app-edp-adr-mapping [catalogId]="catalogId"></app-edp-adr-mapping>
        </div>
        }
        @case ('User Association') {
        <div class="p-1">
            <app-user-association [catalogId]="catalogId"></app-user-association>
        </div>
        }
        @case ('Filter Criteria') {
        <div class="p-1">
            <app-filter-criteria [catalogId]="catalogId"></app-filter-criteria>
        </div>
        }
        @case ('Lot - Sizes Filtration') {
        <div class="p-1">
            <app-lot-size-crtiteria [catalogId]="catalogId"></app-lot-size-crtiteria>
        </div>
        }
        }
    </div>
</ng-container>